<mat-nav-list *ngIf="(isMobile | async).matches">
  <div>
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title class="contrato-tile">
            Contrato: &nbsp; {{contrato?.contrato}}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="content">
          <p>Mercadoria:
            <mat-list>
              <span class="mercadoria-list-item" *ngFor="let mercadoria of contrato?.mercadoria?.mercadorias">
                {{mercadoria}}<br />
              </span>
            </mat-list>
          </p>
          <p>Data de Vencimento: {{normalizedDate(contrato?.vencimento) | date:'dd/MM/yyyy'}}</p>
          <p>Saldo: {{contrato?.saldo | currency:'BRL'}}</p>
          <p>Plano: {{formatarPlanoPorExtenso(contrato)}}</p>
          <p>Parcelas Pagas: {{contrato?.quantidadeParcelasPagas}}</p>
          <p>Situação: {{getStatusContrato(contrato)}}</p>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</mat-nav-list>

<table mat-table *ngIf="!(isMobile | async).matches" [dataSource]="[contrato]" class="mat-elevation-z2 table">
  <ng-container matColumnDef="contrato">
    <th mat-header-cell *matHeaderCellDef>Contrato</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.contrato}}</td>
  </ng-container>

  <ng-container matColumnDef="mercadoria">
    <th mat-header-cell *matHeaderCellDef>Mercadoria</th>
    <td mat-cell *matCellDef="let contrato">
      <span class="mercadoria-table-item" *ngFor="let mercadoria of contrato?.mercadoria?.mercadorias">
        {{mercadoria}}<br />
      </span>
    </td>
  </ng-container>

  <ng-container matColumnDef="dataVencimento">
    <th mat-header-cell *matHeaderCellDef>Data de Vencimento</th>
    <td mat-cell *matCellDef="let contrato">{{normalizedDate(contrato?.vencimento) | date:'dd/MM/yyyy'}}</td>
  </ng-container>

  <ng-container matColumnDef="saldo">
    <th mat-header-cell *matHeaderCellDef>Saldo</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.saldo | currency:'BRL'}}</td>
  </ng-container>

  <ng-container matColumnDef="plano">
    <th mat-header-cell *matHeaderCellDef>Plano</th>
    <td mat-cell *matCellDef="let contrato">{{formatarPlanoPorExtenso(contrato)}}</td>
  </ng-container>

  <ng-container matColumnDef="parcelasPagas">
    <th mat-header-cell *matHeaderCellDef>Parcelas Pagas</th>
    <td mat-cell *matCellDef="let contrato">{{contrato?.quantidadeParcelasPagas}}</td>
  </ng-container>

  <ng-container matColumnDef="situacao">
    <th mat-header-cell *matHeaderCellDef>Situação</th>
    <td mat-cell *matCellDef="let contrato">{{ getStatusContrato(contrato)}}</td>
  </ng-container>

  <tr mat-header-row
    *matHeaderRowDef="['contrato', 'mercadoria', 'dataVencimento', 'saldo', 'plano', 'parcelasPagas', 'situacao']"></tr>
  <tr mat-row
    *matRowDef="let row; columns: ['contrato', 'mercadoria', 'dataVencimento', 'saldo', 'plano', 'parcelasPagas', 'situacao'];">
  </tr>
</table>